import React, { useContext, useEffect } from "react";

import { useHistory } from "react-router-dom";

// Context
import { DataContext } from "contexts/Data";

const LanguagePicker = ({ redirects = { no: "", en: "" }, modifier }) => {
    const { language, setLanguage } = useContext(DataContext);
    const history = useHistory();
    return (
        <div
            className={`language-picker ${
                modifier ? "language-picker--" + modifier : ""
            }`}
        >
            <span
                className={language === "no" ? "language-active" : ""}
                onClick={() => {
                    setLanguage("no");
                    history.push(redirects.no);
                    // window.location.href = redirects.no;
                }}
            >
                NO
            </span>{" "}
            /{" "}
            <span
                className={language === "en" ? "language-active" : ""}
                onClick={() => {
                    setLanguage("en");

                    // window.location.href = redirects.en;
                    history.push(redirects.en);
                    // window.location.reload();
                }}
            >
                EN
            </span>
        </div>
    );
};

export default LanguagePicker;
